import classNames from 'classnames';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class AlertMessage extends Component {
  static get TYPE_ERROR() { return 'error'; }
  static get TYPE_SUCCESS() { return 'success'; }

  renderMessage(message) {
    if (!Array.isArray(message)) {
      return <p>{message}</p>
    } else {
      if (message.length === 0) {
        return null;
      }

      return (
        <ul>{message.map(item => <li>{item}</li>)}</ul>
      );
    }
  }

  render() {
    const { show, type, message } = this.props;

    return (
      <Modal isOpen={show}
        className={classNames(['alert-message', 'alert-message-' + type])}
        contentLabel={type === AlertMessage.TYPE_ERROR ? 'Submission Error' : 'Submission Successful'}>
        <div className="message">
          {this.renderMessage(message)}
        </div>
        <div className="submit">
          <button type="button"
            className="btn btn-primary"
            onClick={() => {
              this.props.hide();
            }}>Close
          </button>
        </div>
      </Modal>
    )
  }
}

AlertMessage.defaultProps = {
  show: false,
  type: '',
  message: '',
  hide: null,
};

AlertMessage.propTypes = {
  show: PropTypes.bool,
  type: PropTypes.string,
  message: PropTypes.string,
  hide: PropTypes.func
};

export default AlertMessage;
